import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"height":"90vh"}
}
const _hoisted_2 = {
  class: "w100 mt10 centered",
  style: {"height":"30px"}
}
const _hoisted_3 = {
  class: "fw600 fs24 mc mt40",
  style: {"width":"200px"}
}
const _hoisted_4 = {
  key: 0,
  class: "fs13 fw600 ddgrey centered mt20"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  id: "decideCalElms",
  class: "mc ofs w95",
  style: {"height":"400px"}
}
const _hoisted_7 = {
  key: 0,
  class: "w80 mt10 ml15",
  style: {}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  class: "w95 ml15 mt20",
  style: {}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "ml15 w100"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_allday_`,
  class: "fs13 pointer"
}, " 終日", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  key: 2,
  class: "mt40 w100",
  style: {}
}
const _hoisted_15 = { class: "fl ml15 w100" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs11 mr10 mt18" }, "オーナー", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_18 = { class: "w100" }
const _hoisted_19 = { class: "fl ml15 mr15 w5" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  class: "fl w80",
  style: {}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { id: "calendarList" }
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = {
  class: "w95 mt40",
  style: {}
}
const _hoisted_28 = { class: "fl mr15 ml15" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  key: 3,
  class: "w95 mt40",
  style: {}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr20 ml15 fs12 fw600" }, " 担当者を選択 ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 4,
  class: "w95 mt40",
  style: {}
}
const _hoisted_35 = { class: "fl mr20 ml15" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = {
  key: 5,
  class: "ml15 mb10 mt40"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: `cal_notice_`,
  class: "fs13 pointer"
}, "会議出席者に招待メールを送る", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = {
  key: 6,
  class: "ml15 mb10 mt40"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_private_`,
  class: "fs13 pointer"
}, " イベントを非公開で保存", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_46 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_47 = {
  class: "posAb w30 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 0,
  class: "posAb w70 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "この日程で確定", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  class: "posAb w70 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_54 = {
  key: 0,
  class: "fs14 whiteColor fw600"
}
const _hoisted_55 = {
  key: 1,
  class: "fs14 whiteColor fw600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_ChangeableDateTimeContent = _resolveComponent("ChangeableDateTimeContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_LblueListContent = _resolveComponent("LblueListContent")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_LocationSelectContent = _resolveComponent("LocationSelectContent")!
  const _component_OneMagSmallContent = _resolveComponent("OneMagSmallContent")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "CalendarEventModal",
    "content-class": "rad10 with_white_bg shadowContent modalWide noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.ev)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.isCustomFixView ? `カスタム確定` : `イベント作成`), 1)
            ]),
            (_ctx.isCustomFixView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " カスタムで確定する場合、既存のイベントを考慮せず強制的に確定します。予め日程を確認の上、ご確定ください。 "))
              : _createCommentVNode("", true),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.isCustomFixView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_MdTextfieldTag, {
                      name: "タイトル",
                      fieldStyle: "min-width:250px;max-width:250px;",
                      style: {"height":"56px","min-width":"250px"},
                      class: "fl fs16",
                      value: _ctx.title,
                      onInputValue: _ctx.inputTitleText,
                      onBlur: _ctx.blurTitleText,
                      required: ""
                    }, null, 8, ["value", "onInputValue", "onBlur"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ChangeableDateTimeContent, {
                  changeableEv: _ctx.ev,
                  onUpdateAppoTime: _ctx.updateAppoTime
                }, null, 8, ["changeableEv", "onUpdateAppoTime"])
              ]),
              _hoisted_10,
              (!_ctx.isCustomFixView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_CheckboxTag, {
                      value: ``,
                      name: `is_allday`,
                      checked: _ctx.ev.allday,
                      prefix: `is_allday`,
                      onClickCheckbox: _ctx.clickChangeAllday,
                      style: {"margin-left":"1px"}
                    }, null, 8, ["checked", "onClickCheckbox"]),
                    _createTextVNode("   "),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true),
              _hoisted_13,
              (!_ctx.isCustomFixView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_SelectTag, {
                        name: "additonal_connected_calendar",
                        id: "additonal_connected_calendar",
                        class: "fl fs14 roundForm noBorder",
                        style: {"min-width":"30px","height":"50px"},
                        options: _ctx.cm.getWritableCalendars().map(cal => cal.name),
                        defaultOption: _ctx.ownerCtag ? _ctx.ownerCtag.name : ``,
                        onSelectValue: _ctx.selectEventOwner
                      }, null, 8, ["options", "defaultOption", "onSelectValue"])
                    ]),
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/logo/menu_icon02.png`),
                          class: "mt5",
                          style: {"width":"18px","height":"18px"}
                        }, null, 8, _hoisted_20)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usedCtags, (ct, ctindex) => {
                          return (_openBlock(), _createBlock(_component_LblueListContent, {
                            key: `${ct.email}${ctindex}`,
                            name: ct.name,
                            value: ct.email,
                            display: ct.type == 1,
                            type: "circle",
                            class: "fl mr5 mb5",
                            showDeleteButton: true,
                            onDeleteContent: _ctx.deleteContent
                          }, null, 8, ["name", "value", "display", "onDeleteContent"]))
                        }), 128)),
                        _hoisted_22,
                        _createVNode(_component_TextfieldTag, {
                          placeholder: "＋出席者を追加",
                          style: {"border-bottom":"solid 1px #c8c8c8"},
                          class: "cal_blanks fw600 fl fs12",
                          list: "calendarList",
                          id: "add_attends",
                          onInputValue: _ctx.addAttendees,
                          onKeyup: _withKeys(_ctx.enterAttendee, ["enter","native"])
                        }, null, 8, ["onInputValue", "onKeyup"]),
                        _createElementVNode("datalist", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctListWithoutSelect, (ct, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              id: ct.email,
                              value: ct.name,
                              class: _normalizeClass(ct.email),
                              onSelect: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAttendees && _ctx.addAttendees(...args)))
                            }, _toDisplayString(ct.name), 43, _hoisted_24))
                          }), 128))
                        ])
                      ]),
                      _hoisted_25
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/logo/menu_icon04.png`),
                    style: {"margin-top":"10px","width":"18px","height":"18px"}
                  }, null, 8, _hoisted_29)
                ]),
                _createVNode(_component_LocationSelectContent, {
                  class: "fl",
                  locationName: _ctx.getLocationName,
                  astag: _ctx.cm.astag,
                  maxLength: 1,
                  onUpdate: _ctx.updateLocation
                }, null, 8, ["locationName", "astag", "onUpdate"])
              ]),
              _hoisted_30,
              (_ctx.isCustomFixView && _ctx.cm.mags)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.mags, (mag, magindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fl mr10",
                        key: magindex
                      }, [
                        _createVNode(_component_OneMagSmallContent, {
                          onSelectMag: _ctx.selectMag,
                          mag: mag,
                          selectedMag: _ctx.selectedMag
                        }, null, 8, ["onSelectMag", "mag", "selectedMag"])
                      ]))
                    }), 128)),
                    _hoisted_33
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isCustomFixView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/logo/text_icon.png`),
                        style: {"margin-top":"10px","width":"18px","height":"18px"}
                      }, null, 8, _hoisted_36)
                    ]),
                    _createVNode(_component_TextareaTag, {
                      placeholder: "＋説明を追加",
                      class: "cal_blanks fl openTextarea pad5",
                      id: "cal_memo",
                      name: "memo",
                      style: {"min-width":"30%","max-width":"98%","border":"1px solid #eee"},
                      onInputValue: _ctx.inputMemo
                    }, null, 8, ["onInputValue"]),
                    _hoisted_37
                  ]))
                : _createCommentVNode("", true),
              _hoisted_38,
              (!_ctx.isCustomFixView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_CheckboxTag, {
                      class: "checkUsingCal lgreyForm",
                      value: ``,
                      name: `cal_notice`,
                      prefix: `cal_notice`,
                      onClickCheckbox: _ctx.checkNotify
                    }, null, 8, ["onClickCheckbox"]),
                    _createTextVNode("   "),
                    _hoisted_40
                  ]))
                : _createCommentVNode("", true),
              _hoisted_41,
              (!_ctx.isCustomFixView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createVNode(_component_CheckboxTag, {
                      value: ``,
                      name: `is_private`,
                      checked: _ctx.cm.astag.is_private,
                      prefix: `is_private`,
                      onClickCheckbox: _ctx.clickRegisterCalPrivate
                    }, null, 8, ["checked", "onClickCheckbox"]),
                    _createTextVNode("   "),
                    _hoisted_43
                  ]))
                : _createCommentVNode("", true),
              _hoisted_44
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("section", {
              class: "llgreyBg dgrey fs16 pointer centered",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _hoisted_49)
          ]),
          (_ctx.isCustomFixView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("section", {
                  class: "w100 pinkBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, _hoisted_52)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("section", {
                  class: "w100 pinkBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, [
                  (_ctx.Util.isPresent(_ctx.ev) && _ctx.Util.isPresent(_ctx.ev.provider_event_id))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, "イベントを更新"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_55, "イベントを作成"))
                ])
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}